import { isKik } from "../../utils/platform";
import { closeWebviewFb, dotFlowCallbackFb } from "../../utils/facebookWebview";
import { closeWebviewKik, dotFlowCallbackKik } from "../../utils/kikWebview";
import { select } from "redux-saga/effects";

export function* callbackToBotSaga(message) {
  try {
    const { _id, username } = yield select(({ user = {} }) => user.data || {});
    if (isKik()) yield dotFlowCallbackKik(_id, username, message);
    else yield dotFlowCallbackFb(_id, message);
  } catch (e) {
    console.log("call err", e);
  }
}

export function* closeWebviewSaga() {
  try {
    if (isKik()) yield closeWebviewKik();
    else yield closeWebviewFb();
  } catch (e) {
    console.log("close err", e);
  }
}



// WEBPACK FOOTER //
// ./src/store/webview/index.js